import React, { createContext, useState } from "react";

interface IUserInfo {
  id: string;
  email: string;
  role: "root" | "admin" | "officer_head" | "officer" | "customer";
  first_name?: string;
  last_name?: string;
  profile_picture?: string;
  mea?: any;
  phone?: string;
  organization?: string;
  address?: string;
  tambon?: string;
  amphoe?: string;
  province?: string;
  zipcode?: string;
  country?: string;
  google?: any;
}

interface IMainContext {
  userInfo: IUserInfo | undefined;
  saveDesign: string | undefined;
  setuserInfo: Function;
  setsaveDesign: Function;
}

const initalState: IMainContext = {
  userInfo: undefined,
  saveDesign: undefined,
  setuserInfo: () => {},
  setsaveDesign: () => {},
};

export const MainContext = createContext<IMainContext>(initalState);
export const MainContextProvider = (props: any) => {
  const [userInfo, setuserInfo] = useState<IUserInfo | undefined>(
    initalState.userInfo
  );
  const [saveDesign, setsaveDesign] = useState(initalState.saveDesign);
  const mainContextValue = { userInfo, setuserInfo, saveDesign, setsaveDesign };
  return (
    <MainContext.Provider value={mainContextValue}>
      {props.children}
    </MainContext.Provider>
  );
};
export const MainContextConsumer = MainContext.Consumer;
